import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Table } from "@material-ui/core";
import TableCell from "@material-ui/core/TableCell";
import Paper from "@material-ui/core/Paper";
import Skeleton from "@mui/material/Skeleton";
import { AiOutlineEye } from "react-icons/ai";
import { BsThreeDots } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import {Box, Button, Dialog, DialogActions, DialogContent, DialogTitle} from "@mui/material";
import {useDispatch} from "react-redux";
import {createAgency, deleteAgency, getAllAgency, updateAgency} from "../../store/action/claim";
import {IoCloseOutline} from "react-icons/io5";
import TablePagination from "@material-ui/core/TablePagination";
import exportToExcel from '../../utils/convertJsonToExcel.js';
import {validateInput} from "../../utils/inputValidation";
import ErrorsAlert from "../../utils/errorsAlert";
const useStyles = makeStyles((theme) => ({
    root: {
        width: "100%",
        minHeight: "85vh",
    },
    tableCellSmall: {
        fontFamily: "Poppins",
        fontWeight: 600,
        fontSize: 14,
        lineHeight: "21px",
        color: "rgba(70, 78, 95, 1)",
        borderBottom: "1px solid  rgba(0, 0, 0, 0.08)",
        whiteSpace: "nowrap",
    },
    paper: {
        width: "100%",
        borderRadius: "11px",
        boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.06)",
    },
    tableWrapper: {
        padding: "40px",
    },
    tableHeadRows: {
        height: "48px",
        whiteSpace: "nowrap",
        fontFamily: "Poppins",
        fontWeight: 600,
        fontSize: 12,
        lineHeight: "18px",
        color: "rgba(181, 181, 195, 1)",
        border: 0,
        background: "rgba(243, 246, 249, 1)",
        padding: "1%",
    },

    tableSortLabel: {
        color: "rgba(32, 29, 35, 1)",
        fontFamily: "Inter",
        fontWeight: 400,
        fontSize: 12,
        lineHeight: "18px",
    },
    titre: {
        fontFamily: "Poppins",
        fontSize: 12,
        fontWeight: 600,
        color: "rgba(63, 66, 84, 1)",
    },
    titreLabel: {
        fontFamily: "Poppins",
        fontSize: 12,
        fontWeight: 400,
        color: "rgba(32, 18, 70, 1)",
    },
    tablePagination: {
        fontFamily: "Poppins",
        fontSize: "12px",
        fontWeight: 400,
        lineHeight: "18px",
        color: "rgba(32, 18, 70, 1)",
    },
    inputContainer: {
        border: "0.61px solid rgba(226, 217, 239, 1)",
        background: "rgba(255, 255, 255, 1)",
        width: "148px",
        height: "29.69px",
        borderRadius: 5,
    },
    naText: {
        color: "rgb(145, 145, 145)",
    },
    line: {
        height: "2px",
        backgroundColor: "rgba(243, 246, 249, 1)",
        width: "100%",
        marginBottom: "16px",
    },
    dialog: {
        width: "600px",
        height: "300px",
        backgroundColor: "#ffffff",
    },
    dialogTitle: {
        backgroundColor: "rgba(244, 244, 244, 1)",
        width: "600px",
        height: "60px",
        color: "#464E5F",
        fontFamily: "Poppins",
        fontSize: "16px",
        fontWeight: 600,
    },
    closeButton: {
        cursor: 'pointer',
        textAlign: "right",
        alignItems: 'center',
    },
    dialogContent: {
        marginTop: "20px",
        padding: "20px",
    },
    inputLabel: {
        fontFamily: "Poppins",
        fontSize: "12px",
        fontWeight: 400,
        color: "rgba(70, 78, 95, 1)",
    },
    dialogInput: {
        width: "100%",
        height: "36px",
        padding: "8px 12px",
        fontFamily: "Poppins",
        fontSize: "14px",
        border: "1px solid #E0E0E0",
        borderRadius: "4px",
        backgroundColor: "rgba(243, 246, 249, 1)",
    },
}));

export default function AgenciesReference(props) {
    const classes = useStyles();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [loading, setLoading] = useState(false);
    const [agencies, setAgencies] = useState([]);
    const [nameFilter, setNameFilter] = useState("");
    const [codeFilter, setCodeFilter] = useState("");
    const [openCreateDialog, setOpenCreateDialog] = useState(false);
    const [openEditDialog, setOpenEditDialog] = useState(false);
    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
    const [selectedAgency, setSelectedAgency] = useState({ code: "", label: "" });
    const [agencyCode, setAgencyCode] = useState("");
    const [agencyLabel, setAgencyLabel] = useState("");
    const [errors, setErrors] = useState([]);

    async function fetchAgencies() {
        setLoading(true);
        try {
            await dispatch(getAllAgency())
                .then((response) => setAgencies(response))
                .catch((error) => console.error("Error fetching agencies:", error));
        } finally {
            setLoading(false);
        }
        console.log("agencies:", agencies)
    }

    useEffect(() => {
        fetchAgencies().then(r => console.log("r"));
    }, [dispatch]);

    const filteredAgencies = agencies.filter(
        (agency) =>
            agency.label.toLowerCase().includes(nameFilter.toLowerCase()) &&
            agency.code.toLowerCase().includes(codeFilter.toLowerCase())
    );

    useEffect(() => {
        const newPage = Math.floor(filteredAgencies.length / rowsPerPage);
        setPage(Math.min(newPage, page));
    }, [filteredAgencies.length, rowsPerPage]);


    const headRows = [
        {
            id: "code",
            align: "center",
            label: "Code Agence",
        },
        {
            id: "label",
            align: "center",
            label: "Nom Agence",
        },
        {
            id: "createdAt",
            align: "center",
            label: "Date Création",
        },
        {
            id: "updatedAt",
            align: "center",
            label: "Date Modification",
        },
        {
            id: "btn",
            align: "center",
        },

    ];

    function getDateFromString(dateString) {
        if (!dateString) return "";
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, "0");
        const day = date.getDate().toString().padStart(2, "0");
        return `${day}/${month}/${year}`;
    }

    function renderField(field) {return field ? field : <span className={classes.naText}>N/A</span>; }

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    function getErrorMessages(error, fallback) {
        const data = error?.response?.data;
        if (Array.isArray(data?.errors) && data.errors.length > 0) return data.errors;
        if (data?.error) return [data.error];
        if (data?.message) return [data.message];
        return [fallback];
    }

    const handleCreateSubmit = () => {
        const newAgency = {
            code: agencyCode.trim(),
            label: agencyLabel.trim(),
        };
        if (!newAgency.code || !newAgency.label) {
            setErrors(["Le code et le nom de l'agence sont obligatoires."]);
            return;
        }
        setErrors([]);
        dispatch(createAgency(newAgency))
            .then(() => {
                setOpenCreateDialog(false);
                setAgencyCode("");
                setAgencyLabel("");
                fetchAgencies();
            })
            .catch((error) => {
                console.error("Error creating agency:", error);
                setErrors(getErrorMessages(error, "Échec de la création de l'agence."));
            });
    };
    const handleDeleteSubmit = () => {
        const agencyId = selectedAgency._id;
        setErrors([]);
        dispatch(deleteAgency(agencyId))
            .then(() => {
                setOpenDeleteDialog(false)
                fetchAgencies();
            })
            .catch((error) => {
                console.error("Error deleting agency:", error);
                setErrors(getErrorMessages(error, "Échec de la suppression de l'agence."));
            });
    };
    const handleEditSubmit = () => {
        const updatedData = {
            code: (selectedAgency.code || "").trim(),
            label: (selectedAgency.label || "").trim(),
        };
        if (!updatedData.code || !updatedData.label) {
            setErrors(["Le code et le nom de l'agence sont obligatoires."]);
            return;
        }
        setErrors([]);
        dispatch(updateAgency(selectedAgency._id, updatedData))
            .then(() => {
                setOpenEditDialog(false);
                fetchAgencies();
            })
            .catch((error) => {
                console.error("Error updating agency:", error);
                setErrors(getErrorMessages(error, "Échec de la mise à jour de l'agence."));
            });
    };
    const handleCreateOpen = () => {
        setErrors([]);
        setOpenCreateDialog(true);
    };
    const handleCreateClose = () => {
        setErrors([]);
        setOpenCreateDialog(false);
    };
    const handleEditOpen = (agency) => {
        setErrors([]);
        setSelectedAgency(agency);
        setOpenEditDialog(true);
    };
    const handleEditClose = () => {
        setErrors([]);
        setOpenEditDialog(false);
    };
    const handleDeleteOpen = (agency) => {
        setErrors([]);
        setSelectedAgency(agency);
        setOpenDeleteDialog(true);
    };
    const handleDeleteClose = () => {
        setErrors([]);
        setOpenDeleteDialog(false);
    };

    function handleExport() {
            if (!Array.isArray(filteredAgencies)) {
                console.error("filteredAgencies is not an array");
                return;
            } 
            const dataExportToExcel = filteredAgencies.map(data => {
                 
                return {
                    
                    "Code Agence":  data.code ||null,
                    "Nom Agence":  data.label||null, 
                    "Date Création":  getDateFromString((data.createdAt))||null ,
                    "Date Modification":    getDateFromString((data.updatedAt))||null
                };
            });
           exportToExcel(dataExportToExcel, 'Agencies Reference.xlsx');
          }
    
    return (
        <div className={classes.root}>
            <Paper className={classes.paper}>
                <div className={classes.tableWrapper}>
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            marginBottom: "40px",
                        }}
                    >
                        <div className={classes.titre} style={{width: "18%"}}>
                            Liste des agences
                        </div>

                        <div style={{display: "flex", alignItems: "center", gap: "20px"}}>
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "15px",
                                }}
                            >
                                <div className={classes.titreLabel} style={{fontWeight: 600, whiteSpace: "nowrap"}}>
                                    Filtrer par
                                </div>
                                <div
                                    className={classes.titreLabel}
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        whiteSpace: "nowrap",
                                    }}
                                >
                                    Nom Agence
                                    <input
                                        type="text"
                                        className={classes.inputContainer}
                                        style={{width: "120px", marginLeft: "10px"}}
                                        onChange={(e) => setNameFilter(e.target.value)}
                                    />
                                </div>
                                <div
                                    className={classes.titreLabel}
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        whiteSpace: "nowrap",
                                    }}
                                >
                                    Code Agence
                                    <input
                                        type="text"
                                        className={classes.inputContainer}
                                        style={{width: "120px", marginLeft: "10px"}}
                                        onChange={(e) => setCodeFilter(e.target.value)}
                                    />
                                </div>
                            </div>
                            <Box display="flex" alignItems="center" gap="10px">
                                {/* <Button
                                    style={{
                                        width: "64px",
                                        height: "27px",
                                        color: "rgba(186, 200, 9, 1)",
                                        borderColor: "rgba(186, 200, 9, 1)",
                                        borderWidth: "1px",
                                        borderStyle: "solid",
                                        borderRadius: "5px",
                                        fontFamily: "Poppins",
                                        fontWeight: "400",
                                        fontSize: "11px",
                                        lineHeight: "16px",
                                    }}
                                    onClick={handleExport}
                                >
                                    Export
                                </Button> */}
                                <Button
                                    style={{
                                        width: "110px",
                                        height: "27px",
                                        color: "rgba(186, 200, 9, 1)",
                                        borderColor: "rgba(186, 200, 9, 1)",
                                        borderWidth: "1px",
                                        borderStyle: "solid",
                                        borderRadius: "5px",
                                        fontFamily: "Poppins",
                                        fontWeight: "400",
                                        fontSize: "11px",
                                        lineHeight: "16px",
                                    }}
                                    onClick={handleCreateOpen}
                                >
                                    Créer Agence
                                </Button>
                            </Box>
                        </div>
                    </div>

                    <Table
                        style={{ tableLayout: "fixed", width: "100%" }}
                        aria-labelledby="tableTitle"
                        size="small"
                    >
                        <tr>
                            {headRows.map((row) => (
                                <TableCell
                                    key={row.id}
                                    height="43px"
                                    align={row.align}
                                    className={classes.tableHeadRows}
                                >
                                    {row.label}
                                </TableCell>
                            ))}
                        </tr>
                        {loading
                            ? [...Array(10)].map((_, index) => (
                                <tr key={index} hover style={{ height: "48px" }}>
                                    <TableCell align="left" className={classes.tableCellSmall}>
                                        <Skeleton animation="wave" />
                                    </TableCell>
                                    <TableCell align="left" className={classes.tableCellSmall}>
                                        <Skeleton animation="wave" />
                                    </TableCell>
                                    <TableCell align="left" className={classes.tableCellSmall}>
                                        <Skeleton animation="wave" />
                                    </TableCell>
                                    <TableCell align="left" className={classes.tableCellSmall}>
                                        <Skeleton animation="wave" />
                                    </TableCell>
                                    <TableCell align="left" className={classes.tableCellSmall}>
                                        <Skeleton animation="wave" />
                                    </TableCell>
                                    <TableCell align="right" className={classes.tableCellSmall}>
                                        <button className={classes.viewBtn}>
                                            <BsThreeDots />
                                        </button>
                                        <button
                                            className={classes.viewBtn}
                                            style={{ marginLeft: "7px" }}
                                        >
                                            <AiOutlineEye />
                                        </button>
                                    </TableCell>
                                </tr>
                            ))
                            : filteredAgencies.length > 0
                                ? filteredAgencies
                                    .slice(
                                        page * rowsPerPage,
                                        page * rowsPerPage + rowsPerPage
                                    )
                                    .map((agency, index) => {
                                        return (
                                            <tr
                                                key={agency.code || index}
                                                hover
                                                style={{
                                                    height: "50px",
                                                    backgroundColor: "rgba(255, 255, 255, 1)",
                                                }}
                                            >
                                                <TableCell
                                                    align="center"
                                                    className={classes.tableCellSmall}
                                                >
                                                    {renderField(agency.code)}
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    className={classes.tableCellSmall}
                                                >
                                                    {renderField(agency.label)}
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    className={classes.tableCellSmall}
                                                >
                                                    {renderField(getDateFromString(agency.createdAt))}
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    className={classes.tableCellSmall}
                                                >
                                                    {renderField(getDateFromString(agency.updatedAt))}
                                                </TableCell>
                                                <TableCell
                                                    align="right"
                                                    className={classes.tableCellSmall}
                                                >
                                                    <button
                                                        style={{
                                                            width: "61px",
                                                            height: "34px",
                                                            borderRadius: "6px",
                                                            background: "rgba(187, 200, 8, 1)",
                                                            border: 0,
                                                            fontFamily: "Poppins",
                                                            fontSize: "12px",
                                                            fontWeight: 600,
                                                            lineHeight: "18px",
                                                            color: "rgba(255, 255, 255, 1)",
                                                            cursor: "pointer",
                                                        }}
                                                        onClick={() => handleEditOpen(agency)}
                                                    >
                                                        Modifier
                                                    </button>
                                                    <button
                                                        style={{
                                                            width: "80px",
                                                            marginLeft: "10px",
                                                            height: "34px",
                                                            borderRadius: "6px",
                                                            background: "rgba(255, 229, 229, 1)",
                                                            border: 0,
                                                            fontFamily: "Poppins",
                                                            fontSize: "12px",
                                                            fontWeight: 600,
                                                            lineHeight: "18px",
                                                            color: "rgba(255, 54, 54, 1)",
                                                            cursor: "pointer",
                                                        }}
                                                        onClick={() => handleDeleteOpen(agency)}
                                                    >
                                                        Supprimer
                                                    </button>
                                                </TableCell>
                                            </tr>
                                        );
                                    })
                                : (
                                    <tr>
                                        <TableCell
                                            align="center"
                                            style={{
                                                fontFamily: 'Poppins',
                                                fontWeight: 400,
                                                fontSize: 15,
                                                lineHeight: '22.5px',
                                                color: 'rgba(70, 78, 95, 1)',
                                                padding: '20px'
                                            }}
                                            colSpan="6"
                                        >
                                            Aucune agence disponible
                                        </TableCell>
                                    </tr>
                                )
                        }
                    </Table>
                    <TablePagination
                        rowsPerPageOptions={[10, 20, 30]}
                        component="div"
                        count={filteredAgencies?.length || 0}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        backIconButtonProps={{
                            "aria-label": "Previous Page",
                        }}
                        nextIconButtonProps={{
                            "aria-label": "Next Page",
                        }}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                        style={{
                            fontFamily: "Poppins",
                            fontSize: "12px",
                            fontWeight: 400,
                            lineHeight: "18px",
                            color: "rgba(32, 18, 70, 1)",
                        }}
                        labelRowsPerPage="Lignes par page"
                    />
                </div>
            </Paper>

            <Dialog open={openCreateDialog} onClose={handleCreateClose} classes={{ paper: classes.dialog }}>
                <DialogTitle className={classes.dialogTitle}>Création Agence
                    <IoCloseOutline style={{marginLeft: "377px",}} className={classes.closeButton} size={24} onClick={handleCreateClose} />
                </DialogTitle>
                <DialogContent className={classes.dialogContent}>
                    <label className={classes.inputLabel}>Code Agence</label>
                    <input
                        maxLength={3}
                        id="agencyCode"
                        className={classes.dialogInput}
                        value={agencyCode}
                        onChange={(e) => {
                            const value = e.target.value;
                            if (/^\d*$/.test(value)) {
                                setAgencyCode(value);
                            }
                        }}
                    />

                    <label className={classes.inputLabel}>Nom Agence</label>
                    <input
                        id="agencyLabel"
                        className={classes.dialogInput}
                        value={agencyLabel}
                        onChange={(e) => {
                            if (validateInput(e.target.value)) {
                                setAgencyLabel(e.target.value);
                                setErrors([]);
                            } else {
                                setErrors(["Les caractères spéciaux ne sont pas autorisés."]);
                            }
                        }}
                    />
                    <ErrorsAlert open={errors.length > 0} errors={errors} handleClose={() => setErrors([])} />
                </DialogContent>
                <DialogActions style={{backgroundColor: "rgba(244, 244, 244, 1)"}}>
                    <Button
                        onClick={handleCreateClose}
                        style={{
                            backgroundColor: "rgba(255, 229, 229, 1)",
                            color: "rgba(255, 54, 54, 1)",
                            fontFamily: "Poppins",
                            fontSize: "10.76px",
                            fontWeight: 600,
                            lineHeight: "16.14px",
                            textAlign: "left",
                            textUnderlinePosition: "from-font",
                            textDecorationSkipInk: "none",
                            width: "62px",
                            height: "26px",
                            borderRadius: "5.38px",
                            border: "1px solid rgba(255, 229, 229, 1)",
                            "&:hover": {
                                backgroundColor: "#F4F4F4",
                            },
                        }}
                    >
                        Annuler
                    </Button>
                    <Button
                        onClick={handleCreateSubmit}
                        style={{
                        backgroundColor: "rgba(60, 101, 86, 1)",
                        color: "rgba(255, 255, 255, 1)",
                        fontFamily: "Poppins",
                        fontSize: "10.76px",
                        fontWeight: 600,
                        lineHeight: "16.14px",
                        textAlign: "left",
                        textUnderlinePosition: "from-font",
                        textDecorationSkipInk: "none",
                        width: "61.08px",
                        height: "26.71px",
                        borderRadius: "5.38px",
                        "&:hover": {
                            backgroundColor: "rgba(50, 91, 76, 1)",
                        }
                    }}>Valider</Button>
                </DialogActions>
            </Dialog>

            <Dialog open={openEditDialog} onClose={handleEditClose}>
                <DialogTitle  className={classes.dialogTitle}>Modifier Agence
                    <IoCloseOutline style={{marginLeft: "380px",}} className={classes.closeButton} size={24} onClick={handleEditClose} />
                </DialogTitle>
                <DialogContent className={classes.dialogContent}>
                    <label className={classes.inputLabel}>
                        Code Agence
                    </label>
                    <input
                        maxLength={3}
                        className={classes.dialogInput}
                        value={selectedAgency.code}
                        onChange={(e) => {
                            const value = e.target.value;
                            if (/^\d*$/.test(value)) {
                                setSelectedAgency({ ...selectedAgency, code: value });
                            }}}
                    />
                    <label className={classes.inputLabel}>
                        Nom Agence
                    </label>
                    <input
                        className={classes.dialogInput}
                        value={selectedAgency.label}
                        onChange={(e) => {
                            if (validateInput(e.target.value)) {
                                setSelectedAgency({ ...selectedAgency, label: e.target.value })
                                setErrors([]);
                            } else {
                                setErrors(["Les caractères spéciaux ne sont pas autorisés."]);
                            }
                        }}
                    />
                    <ErrorsAlert open={errors.length > 0} errors={errors} handleClose={() => setErrors([])} />
                </DialogContent>
                <DialogActions style={{backgroundColor:"rgba(244, 244, 244, 1)"}}>
                    <Button
                        onClick={handleEditClose}
                        style={{
                            backgroundColor: "rgba(255, 229, 229, 1)",
                            color: "rgba(255, 54, 54, 1)",
                            fontFamily: "Poppins",
                            fontSize: "10.76px",
                            fontWeight: 600,
                            //lineHeight: "16.14px",
                            textAlign: "left",
                            textUnderlinePosition: "from-font",
                            textDecorationSkipInk: "none",
                            width: "62px",
                            height: "26px",
                            borderRadius: "5.38px",
                            border: "1px solid rgba(255, 229, 229, 1)",
                            "&:hover": {
                                backgroundColor: "#F4F4F4",
                            },
                        }}
                    >
                        Annuler
                    </Button>
                    <Button
                        onClick={handleEditSubmit}
                        style={{
                        backgroundColor: "rgba(60, 101, 86, 1)",
                        color: "rgba(255, 255, 255, 1)",
                        fontFamily: "Poppins",
                        fontSize: "10.76px",
                        fontWeight: 600,
                        lineHeight: "16.14px",
                        textAlign: "left",
                        textUnderlinePosition: "from-font",
                        textDecorationSkipInk: "none",
                        width: "100px",
                        height: "26.71px",
                        borderRadius: "5.38px",
                        "&:hover": {
                            backgroundColor: "rgba(50, 91, 76, 1)",
                        }
                    }}
                    >
                        Valider
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog open={openDeleteDialog} onClose={handleDeleteClose}>
                <DialogTitle className={classes.dialogTitle}>Supprimer Agence
                    <IoCloseOutline style={{marginLeft: "360px",}}  className={classes.closeButton} size={24} onClick={handleDeleteClose} />
                </DialogTitle>
                <DialogContent className={classes.dialogContent}>
                    Êtes-vous sûr de vouloir supprimer l'agence <strong>{selectedAgency.label}</strong> ?
                    <ErrorsAlert open={errors.length > 0} errors={errors} handleClose={() => setErrors([])} />
                </DialogContent>
                <DialogActions>
                    {/*<Button*/}
                    {/*    onClick={handleDeleteClose}*/}
                    {/*    style={{*/}
                    {/*            width: "80px",*/}
                    {/*            marginLeft: "10px",*/}
                    {/*            height: "34px",*/}
                    {/*            borderRadius: "6px",*/}
                    {/*            background: "rgba(255, 229, 229, 1)",*/}
                    {/*            border: 0,*/}
                    {/*            fontFamily: "Poppins",*/}
                    {/*            fontSize: "12px",*/}
                    {/*            fontWeight: 600,*/}
                    {/*            lineHeight: "18px",*/}
                    {/*            color: "rgba(255, 54, 54, 1)",*/}
                    {/*    }}>Annuler*/}
                    {/*</Button>*/}
                    <Button
                        onClick={handleDeleteSubmit}
                        style={{
                            width: "80px",
                            marginLeft: "10px",
                            height: "34px",
                            borderRadius: "6px",
                            background: "rgba(255, 229, 229, 1)",
                            border: 0,
                            fontFamily: "Poppins",
                            fontSize: "12px",
                            fontWeight: 600,
                            lineHeight: "18px",
                            color: "rgba(255, 54, 54, 1)",
                        }}>Supprimer
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}
